import { CheckBoxOutlineBlank } from '@mui/icons-material'
import { Box, Checkbox } from '@mui/material'
import theme from '@theme'

// Define custom SVG for the checkmark
const CustomCheckmarkSVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      fill={theme.palette.neutralVariant100}
      d="M9 16.2l-3.5-3.5-1.4 1.4 5.2 5.2 12-12-1.4-1.4z"
    />
  </svg>
)
interface Props {
  checked: boolean
}
const CheckboxControl = ({ checked }: Props) => (
  <Checkbox
    checked={checked}
    sx={{ color: theme.palette.neutralVariant100 }}
    icon={
      <CheckBoxOutlineBlank
        style={{
          backgroundColor: checked ? theme.palette.purple : theme.palette.neutralVariant100,
          borderRadius: '2px',
          width: '24px',
          height: '24px',
        }}
      />
    }
    checkedIcon={
      <Box
        style={{
          backgroundColor: theme.palette.purple,
          borderRadius: '2px',
          width: '24px',
          height: '24px',
        }}
      >
        {CustomCheckmarkSVG}
      </Box>
    }
  />
)

export default CheckboxControl
